import { render, staticRenderFns } from "./Item4.vue?vue&type=template&id=6c55d6d8"
import script from "./Item4.vue?vue&type=script&lang=js"
export * from "./Item4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports